import { io, Socket } from 'socket.io-client';
import { ORCAMENTO_CILIA_HABILITADO } from './orcamentoCiliaApi';

/**
 * Conexão websocket do Orçamento Cilia (ADR 0003 do módulo).
 *
 * ⚠️ **É um singleton de propósito**, como o do Portal: o hook global
 * (`useOrcamentoCiliaSocket`, montado no `App.tsx`) abre a conexão, e qualquer tela que
 * venha a precisar dela depois precisa da **mesma** — duas conexões dariam duas sessões no
 * servidor e dobrariam os eventos recebidos.
 *
 * Ninguém deve chamar `io()` para o Cilia fora deste arquivo.
 */
let socket: Socket | null = null;

export function conectarCiliaSocket(token: string): Socket | null {
  if (!ORCAMENTO_CILIA_HABILITADO) return null;
  if (socket) return socket;

  socket = io(process.env.REACT_APP_ORCAMENTO_CILIA_URL ?? '', {
    reconnectionDelay: 2000,
    // O backend valida este JWT no handshake e deriva as salas (usuário, papel e módulo) do
    // próprio token — payload autodeclarado nunca dá acesso a sala.
    auth: { token },
  });

  return socket;
}

/** A conexão viva, para quem precisar dela. `null` sem conexão. */
export function obterCiliaSocket(): Socket | null {
  return socket;
}

export function desconectarCiliaSocket() {
  socket?.disconnect();
  socket = null;
}
